import * as TombstoneOperations from "./actions/tombstoneOperations";
// Export TombstoneOperations API
export default TombstoneOperations;

// Export public types
export { default as TombstoneReasonType } from "./types/TombstoneReasonType";
